<template>
  <div class="child-message-view">
    <error-view v-if="hasError" module="message"/>
    <template v-else>
      <van-nav-bar
        class="file-header nav-bar-bgcolor"
        :title="$t('message.type.collab')"
        @click-left="back"
      >
        <i v-if="showLeft" slot="left" class="iconfont icon-back"/>
      </van-nav-bar>
      <ul :class="['child-message-main', !childMessages.length && 'content-center']" @scroll.passive="onScroll">
        <van-loading v-if="isFetching && !childMessages.length"/>
        <template v-else-if="!childMessages.length">
          <svg-icon icon="empty-default"/>
          <p>{{$t('message.empty')}}</p>
        </template>
        <li v-for="item of childMessages" :key="item.id">
          <child-message-item :item="item" @message-delete="handleRemoveMessage"/>
        </li>
        <li v-if="pageNumber < pageCount && childMessages.length" key="more" class="loading-more">
          <van-loading/>
          {{$t('base.loading')}}
        </li>
      </ul>
    </template>
  </div>
</template>
<script>
import debounce from 'lodash/debounce'
import ajax from '@/utils/ajax'
import {i18n} from '@/utils/i18n'
import {CHILD_MESSAGES_LIST} from '@/config/api'
import ChildMessageItem from './ChildMessageItem'
import ErrorView from '../utils/ErrorView'
import {ua} from '@/utils/common'

export default {
  name: 'ChildMessageList',
  i18n,
  components: {
    ChildMessageItem,
    ErrorView
  },
  props: {
    show: Boolean
  },
  data () {
    return {
      childMessages: [],
      requestPageNumber: 1,
      pageNumber: 1,
      pageCount: 1,
      isFetching: false,
      hasError: false,
      showLeft: false
    }
  },
  watch: {
    show (show) {
      if (show) {
        this.requestPageNumber = 1
        this.childMessages = []
        this.hasError = false
        this.fetchList()
      }
    },
    'store.navStatus' (navStatus) {
      // 新建文件夹并进入
      console.log('store.navStatus', navStatus)
      if (navStatus === 0) {
        this.showLeft = true
      }
    }
  },
  created () {
    this.fetchList()
  },
  mounted () {
    if (!ua.fengyun) {
      this.showLeft = true
    } else if (ua.fengyun && this.store.navStatus === 0) {
      this.showLeft = true
    }
  },
  methods: {
    fetchList () {
      this.isFetching = true
      const { id } = this.$route.params
      ajax({
        url: `${CHILD_MESSAGES_LIST}?message_id=${id}&page_number=${this.requestPageNumber}`,
        accept_all_errors: true
      }).then(res => {
        if (res && res.success) {
          // eslint-disable-next-line eqeqeq
          if (res.page_number == 1) {
            this.childMessages = res.child_messages
          } else {
            this.childMessages = this.childMessages.concat(res.child_messages)
          }
          this.pageNumber = this.requestPageNumber = res.page_number
          this.pageCount = res.page_count
        } else if (res && res.errors) {
          this.hasError = true
        }
        this.isFetching = false
      })
    },
    onScroll: debounce(function (e) {
      if (!this.isFetching && e.target.scrollTop + e.target.clientHeight > e.target.scrollHeight - 200 && this.pageNumber < this.pageCount) {
        this.requestPageNumber++
        this.fetchList()
      }
    }, 500),
    handleRemoveMessage (id) {
      this.childMessages = this.childMessages.filter(item => item.id !== id)
    },
    back () {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="postcss">
.child-message-view {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #eeeff5;

  &>* {
    flex: 0 0 auto;
  }

  & .child-message-main {
    flex: 1 1 auto;
    overflow: auto;
  }
}
</style>
